import { gql } from "@apollo/client";

export const GET_DEPTS = gql`
  query getDepts($orgId: Int!) {
    departmentByOrg(orgId: $orgId) {
      deptId
      name
      category
      orgId
    }
  }
`;

export const CREATE_DEPTS_AND_ROLES = gql`
  mutation CreateDepartmentAndRoles($input: createDepartmentAndRolesInput) {
    createDepartmentAndRoles(input: $input)
  }
`;

export const UPDATE_DEPTS_AND_ROLES = gql`
  mutation UpdateDepartmentAndRoles($input: updateDepartmentAndRolesInput) {
    updateDepartmentAndRoles(input: $input)
  }
`;
export const GET_DEPTS_BY_ORGID = gql`
  query GetDepartmentByOrgId($orgId: Int!) {
    getDepartmentByOrgId(orgId: $orgId) {
      name
      deptId
      category
      orgId
    }
  }
`;
export const GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID = gql`
  query GetScreenMappedUnMappedRoles($orgId: Int) {
    getScreenMappedUnMappedRoles(orgId: $orgId) {
      mapped {
        deptId
        roles {
          roleId
          name
          deptId
        }
      }
      unmapped {
        deptId
        roles {
          roleId
          name
        }
      }
    }
  }
`;

export const DELETE_DEPARTMENT = gql`
  mutation DeleteDepartment($deptId: Int!, $orgId: Int!) {
    deleteDepartment(deptId: $deptId, orgId: $orgId)
  }
`;
